import dynamic from 'next/dynamic';
export const PbWrapper = dynamic(() => import('./EditorMode/PbWrapper'));
//# sourceMappingURL=index.js.map